module.exports = __webpack_public_path__ + "static/media/info01comoadministrar.b22e2d8.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/info01comoadministrar.mp4
// module id = 817
// module chunks = 1